module.exports = __webpack_public_path__ + "img/119.1ebc9881.jpg";